import{_ as e}from"./_freeGlobal.js";var t=e,s="object"==typeof self&&self&&self.Object===Object&&self,f=t||s||Function("return this")();export{f as _};
//# sourceMappingURL=_root.js.map
